export default {

    LOAD_PROPOSAL(state, proposal) {
        state.items = proposal;
    }

}